import { useContext } from 'react';
import InventoryContext from '~/context/srp/InventoryContext';
import useCheckExperimentBucket from '~/hooks/srp/useCheckExperimentBucket';
import ResultTiles from './SimilarResults';
import { SimilarResultsHeader } from './SimilarResultSection.styles';
import { ResultsSection } from '../ResultsSection.styles';

export default function SimilarResultsSection() {
  const {
    similarVehicles: { vehicles }
  } = useContext(InventoryContext);
  const hasSimilarResults = vehicles.length > 0;
  const isInExperiment = useCheckExperimentBucket(
    'srch-impossible-facets2',
    'experiment'
  );

  return hasSimilarResults ? (
    <>
      {isInExperiment ? (
        <div className="pb-16 text-blue-7 text-center tl-header-m m:pb-24 m:tl-header-xl">
          View Similar Vehicles
        </div>
      ) : (
        <SimilarResultsHeader data-qa="similar-results-wrapper">
          Check out similar matches
        </SimilarResultsHeader>
      )}
      <ResultsSection>
        <ResultTiles vehicles={vehicles} />
      </ResultsSection>
    </>
  ) : null;
}
